module.exports = __webpack_public_path__ + "static/media/apple.66aac482.png";